import React from "react";
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Stack } from '@/components/ui/layout';
import { cn } from '@/lib/utils';

const JobDetails = ({ experience, location }) => {
  return (
    <Card className={cn("rounded-t-2xl bg-primary/25 border border-muted p-7 mt-24 w-full max-w-[1517px] ml-0.5")}>
      <CardContent className="p-0">
        <Stack spacing="sm">
          <Heading level="h2" className="text-2xl font-medium tracking-wide">
            Software Developer
          </Heading>
          <Text variant="muted" size="lg" className="flex items-start gap-3.5 tracking-wide">
            {location} | {experience} years
          </Text>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default JobDetails;